<template>
  <default>
    <div class="cps-shell">
      <div class="cust-breadcrumb">
        <bread-crumb :breadcrumbs="breadcrumbs" />
      </div>

      <div class="cust-page-header">
        <div>
          <h1 class="cust-ui-title">Pacis products</h1>
          <p class="cust-ui-subtitle">Browse cover and start a quote or purchase.</p>
        </div>
        <router-link :to="{ name: 'Dashboard' }" class="cust-ui-link cps-back-link">
          <v-icon small color="#184679">mdi-arrow-left</v-icon>
          Dashboard
        </router-link>
      </div>

      <customer-agent-picker />

      <div class="cps-tabs" role="tablist">
        <button
          v-for="cat in categories"
          :key="cat.id"
          type="button"
          role="tab"
          :class="['cps-tab', activeCategory === cat.id ? 'cps-tab--active' : '']"
          :aria-selected="activeCategory === cat.id"
          @click="activeCategory = cat.id"
        >
          {{ cat.label }}
        </button>
      </div>

      <customer-product-tray
        variant="catalog"
        :category="activeCategory"
      />

      <p class="cps-help-footer">
        Need help? Visit
        <router-link :to="{ name: 'Claims' }">claims</router-link>
        or
        <router-link :to="{ name: 'MyPolicies' }">my policies</router-link>.
      </p>
    </div>
  </default>
</template>

<script>
import Default from '@/components/layout/Default';
import BreadCrumb from '@/components/dashboard/BreadCrumb';
import CustomerProductTray from '@/components/customer/CustomerProductTray';
import CustomerAgentPicker from '@/components/shared/CustomerAgentPicker';
import { CUSTOMER_PRODUCT_CATEGORIES } from '@/constants/customerProducts';

export default {
  name: 'CustomerProductSelect',
  components: {
    Default,
    BreadCrumb,
    CustomerProductTray,
    CustomerAgentPicker,
  },
  data() {
    return {
      activeCategory: 'all',
      categories: CUSTOMER_PRODUCT_CATEGORIES,
    };
  },
  computed: {
    breadcrumbs() {
      return [{ text: 'Products', disabled: true, to: { name: 'CustomerProductSelect' } }];
    },
  },
  async mounted() {
    await this.$store.dispatch('referral/ensureReferralValidated', this.$route.query);
  },
  metaInfo: { title: 'Products' },
};
</script>

<style scoped src="@/assets/css/customer-product-select.css"></style>
